import { BackgroundGradient } from '@blocks/kit';
import TableOfProps from "../../../../src/table-of-props";
import React from 'react';
export default {
  BackgroundGradient,
  TableOfProps,
  React
};